import React, { useState, useEffect } from 'react';
import { fetchTransactionDetails, fetchdata, setActivity, getdata } from '../../Global/Index.js';
import './DropdownInput.css';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
 
 
const DropdownInput = ({ setData }) => {
    const [selectedValue, setSelectedValue] = useState("");
    const [options, setOptions] = useState([]);
    const theme = useTheme();
    let OppertunityId = null;
 
   
    useEffect(()=>{
    const getdatafunction=async()=>{
 
        const data = await getdata();
        if (data.response.status === '200') {
            OppertunityId = data.response.data.OpportunityId;
        } else if (data.response.status === "503") {
            toast.warn(data.response.message);
        } else if (data.response.status === "419") {
            window.location.href = '/Session-Expired';
        }else if(data.response.status==='401'){
                window.location.href='/'
         }
    }
   
    getdatafunction()
    },[setData])
   
 
    const getCurrentFinancialYear = (date) => {
        // Check if the input is a string and convert it to a Date object
        const currentDate = typeof date === 'string' ? new Date(date) : date;
 
        // Ensure currentDate is a valid Date object
        if (!(currentDate instanceof Date) || isNaN(currentDate)) {
            throw new Error('Invalid date provided');
        }
 
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
 
        return currentMonth >= 4
            ? `${currentYear}-${currentYear + 1}`
            : `${currentYear - 1}-${currentYear}`;
    };
 
    const getDateData = (disbursementYear, currentFinancialYear) => {
        const [startYear] = disbursementYear.split('-');
        const [endYear] = currentFinancialYear.split('-');
 
        const updatedOptions = [];
        for (let year = parseInt(startYear); year <= parseInt(endYear); year++) {
            updatedOptions.push({
                value: `${year}-${year + 1}`,
                label: `${year}-${year + 1}`
            });
        }
 
        setOptions(updatedOptions);
    };
 
    const callingFun = React.useCallback(async () => {
 
        setActivity('Transaction Details Page');
       
        await fetchdata().then((datas) => {
            if (datas.response.status === "200") {
                datas.response.data.loanList.forEach((loan) => {
                    if (loan.oppertunityId === OppertunityId) {
                        const currentFinancialYear = getCurrentFinancialYear(new Date());
                        let disbursementDate = loan.timeline.Disbursementdate;
                        if (!disbursementDate) {
                            // toast.warn("")
                            setData({ transaction: [], summary: [] });
                            return 0;
                        }
                        let disbursementYear = getCurrentFinancialYear(disbursementDate);
 
 
                        getDateData(disbursementYear, currentFinancialYear)
                        setSelectedValue(currentFinancialYear);
                    }
                })
            }
            else if(datas.response.status === "419") {
                window.location.href = '/Session-Expired'
            } else if (datas.response.status === "500") {
                toast.error('Something went wrong. Please try again later!')
            }
        }).catch((error) => {
            console.log(`error in dashboard api of Interest Rate movement page ${error}`)
        });
    }, [setData , OppertunityId]);
 
    useEffect(() => {
        const funToGetDisbursementDate = async () => {
            callingFun();
        }
 
        funToGetDisbursementDate();
    }, [callingFun]);
 
 
 
    useEffect(() => {
   
        const fetchData1 = async () => {
            const val = getDateRangeFromFinancialYear(selectedValue);
            const res = await fetchTransactionDetails(val);
             if (res.response.status === 200 && res.response.data) {
                setData(res.response.data);
            } else if(res.response.status === "419") {
                window.location.href = '/Session-Expired'
            }
        };
 
        if (selectedValue) { // Ensure selectedValue is not empty before fetching
            fetchData1();
        }
    } , [selectedValue, setData]);
 
    const getDateRangeFromFinancialYear = (year) => {
        const [startYear, endYear] = year.split('-');
        const fromdate = `01-04-${startYear}`; // Start date: 1st April of the starting year
        const todate = `31-03-${parseInt(startYear) + 1}`; // End date: 31st March of the next year
        return { fromdate, todate };
    };
 
    const handleSelectChange = async (e) => {
        e.preventDefault();
        const value = e.target.value;
        setSelectedValue(value);
    }
 
    return (
        <div>
            <ToastContainer />
            {selectedValue !== "" && <label>
                <select onChange={handleSelectChange} value={selectedValue} className='dropdownButtontransaction' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                    {options.map(option => (
                        <option key={option.value} value={option.value}>
                            Financial Year {option.label}
                        </option>
                    ))}
                </select>
            </label>}
            <br />
        </div>
    );
};
 
DropdownInput.propTypes = {
    setData: PropTypes.func.isRequired,
};
 
export default DropdownInput;
 